import React from 'react';
import { useTranslation } from 'react-i18next';
import { UnlinkIcon } from 'assets/icons';
import { TooltipContent } from 'pages/EstimatePage/TableSection/TableSection.styled';
import { Flex, Icon, WithTooltip } from 'UI';

interface IncompatibleReferenceIndicatorProps {
  isCustom: boolean;
  isCompatible: boolean;
}

export function IncompatibleReferenceIndicator({
  isCustom,
  isCompatible,
}: Readonly<IncompatibleReferenceIndicatorProps>) {
  const { t } = useTranslation();

  if (isCustom || isCompatible) {
    return null;
  }

  return (
    <WithTooltip
      title={t('estimate.reference.noncompatible', 'Not compatible with selected vehicle')}
      placement={'top'}
    >
      <TooltipContent data-cy={'incompatible-vehicle-tooltip'}>
        <Flex size={0} align={'center'} justify={'center'}>
          <Icon IconComponent={UnlinkIcon} size={16} color={'black'} display={'inline'} />
        </Flex>
      </TooltipContent>
    </WithTooltip>
  );
}
